// extracted by mini-css-extract-plugin
module.exports = {"icon":"CustomRadioButtonField_icon__gVwC-"};